<template>
    <modal id="update-space-modal" size="xl">
        <template slot="title">Update Space</template>
        <template slot="body">

            <div class="inputs">
                <field-input v-model="form.building" placeholder="Building Number"></field-input>
                <field-input v-model="form.floor" placeholder="Floor Number"></field-input>
                <field-input v-model="form.name" placeholder="Space Name"></field-input>
                <field-select v-model="form.type" placeholder="Space Type">
                    <option v-for="type in spaceTypes" :value="type.id" v-text="type.label"></option>
                </field-select>
                <div class="form-group">
                    <label for="forms" class="mb-2">Available Forms:</label>
                    <table class="table table-sm">
                        <tr v-for="form in forms">
                            <td>
                                <div class="text-muted" v-text="form.name"></div>
                                <div class="text-info text-sm" v-text="form.group.code"></div>
                            </td>
                            <td>
                                <button @click.prevent="addForm(form)" class="btn btn-sm btn-default border">
                                    <i class="fa fa-plus ml-1"></i>
                                </button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="w-100">

                <div class="p-4">
                    <p>Tests</p>
                    <table class="table table-sm table-striped">
                        <tr v-for="(form, index) in form.forms" :key="`tests-${form.id}-${index}`" :class="{'bg-adding' : !form.test }">
                            <td>
                                <div v-text="form.name"></div>
                                <div class="d-flex align-items-center">
                                    <test-result-icon class="mr-1" v-if="form.test" :tooltip="false" :form="form"></test-result-icon>
                                    <div class="text-info text-sm" v-text="form.group.code"></div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex">
                                    <button @click.prevent="removeForm(form, index)" class="btn btn-sm btn-default border ml-auto">
                                        <i class="fa fa-times ml-1"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr v-for="(form, index) in form.excluding" :key="`excluding-${form.id}-${index}`" class="bg-removing">
                            <td>
                                <div v-text="form.name"></div>
                                <div class="d-flex align-items-center">
                                    <test-result-icon class="mr-1" v-if="form.test" :tooltip="false" :form="form"></test-result-icon>
                                    <div class="text-info text-sm" v-text="form.group.code"></div>
                                </div>
                            </td>
                            <td>
                               <div class="d-flex">
                                   <button @click.prevent="cancelRemove(form, index)" class="btn btn-sm btn-default border ml-auto">
                                       <i class="fa fa-reply ml-1"></i>
                                   </button>
                               </div>
                            </td>
                        </tr>
                    </table>
                </div>

            </div>

        </template>
        <template slot="footer">
            <button class="btn btn-default" type="button" @click="closeModal('update-space-modal')">Close</button>
            <button class="btn btn-success" type="button" @click="save()">Save</button>
        </template>
    </modal>
</template>
<script>

    let SpaceTypes = require('@/mixins/SpaceTypes')

    export default {

        mixins: [SpaceTypes],

        props: {
            project: {
                type: Object,
                required: true,
            },
            space: {
                type: Object,
                required: true,
            },
            forms: {
                type: Array,
                required: true,
            }
        },

        data() {
            return {
                form: new Form({
                    building: this.space.building,
                    floor: this.space.floor,
                    name: this.space.name,
                    forms: this.space.forms,
                    type: this.space.type,
                    excluding: [],
                    adding: []
                }).dontClear(),
            }
        },

        created() {
            this.form.forms = _.map(this.space.forms, form => {
                return form;
            });
        },

        methods: {
            save() {
                if (this.validate()) {
                    this.form.patch(`/projects/${this.project.slug}/spaces/${this.space.slug}`).then(response => {
                        Toast.success(`Space ${response.space.name} has been updated!`)
                        App.bus.$emit('refresh-space-areas', response.space)

                        this.form.forms = response.space.forms;
                        this.form.excluding=[]
                        this.form.adding=[]
                        this.closeModal('update-space-modal')
                    }).catch(error => {
                        Alert.error(error.first());
                    })
                }
            },

            addForm(form){
                // this.validate()
                this.form.forms.push(form)
                if (!form.test) {
                    this.form.adding.push(form)
                }

            },

            removeForm(form, index) {
                this.form.forms.splice(index, 1);
                if (form.test) {
                    this.form.excluding.push(form);
                } else {
                    let addingIndex = _.findIndex(this.form.adding, f => f.id == form.id)
                    this.form.adding.splice(addingIndex, 1);
                }
            },

            cancelRemove(form, index) {
                this.form.excluding.splice(index, 1);
                if (form.test) {
                    this.form.forms.push(form);
                }
            },

            validate() {

                if (this.authorize('admin')) {
                    return true;
                }

                if (this.project.version == 2019) {

                    var nrca_lti_05_A = [25, 26];

                    if (this.form.forms.includes(nrca_lti_05_A[0]) && this.form.forms.includes(nrca_lti_05_A[1])) {
                        Alert.error('You only can select one of the NRCA-LTI-05-A forms')
                        return false;
                    }
                }

                return true;
            },
        }

    }
</script>
